import React, { Component } from 'react'
import '../style/loader.scss'

export default class Loader extends Component {
    render() {
        const { style = {}, innerStyle = {} } = this.props;
        return (
            <div style={style} className={"loader-container"} >
                <div style={innerStyle} className="loader">
                </div>
            </div>
        )
    }
}
